import { render } from "./LiveCasino.vue?vue&type=template&id=66c94312&scoped=true"
import script from "./LiveCasino.vue?vue&type=script&lang=js"
export * from "./LiveCasino.vue?vue&type=script&lang=js"

import "./LiveCasino.vue?vue&type=style&index=0&id=66c94312&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66c94312"

export default script